/**
 * Copyright (c) 2026, CYBRA Corp.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { BaseService } from './base-service';
import { RestService } from './rest-service';
import { Url_Base } from 'app/rest-constants';

export interface CsvUploadResultDto {
    inserted: number;
    failed: number;
}

export interface UploadJobStatusDto {
    jobId: string;
    status: 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
    processed: number;
    failed: number;
    message?: string;
}


@Injectable({ providedIn: 'root' })
export class DataMappingUploadService extends BaseService {

    constructor(
        router: Router,
        authenticationService: AuthenticationService,
        private restService: RestService
    ) {
        super(router, authenticationService);
    }

    private baseUrl(): string {
        return `${Url_Base}/data-mapping-upload`;
    }

    upload(
        mappingHeaderId: number,
        file: File
    ): Promise<CsvUploadResultDto> {

        const formData = new FormData();
        formData.append('mappingHeaderId', mappingHeaderId.toString());
        formData.append('file', file);

        // ✅ NO headers object
        return this.restService.upload<CsvUploadResultDto>(
            this.baseUrl(),
            formData
        );
    }

    getStatus(jobId: string): Promise<UploadJobStatusDto> {
        const url = `${this.baseUrl()}/${jobId}`;
        return this.restService.get<UploadJobStatusDto>(url);
    }
}